var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "agent-performance" }, [
    _c("div", { staticClass: "chart-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", { staticClass: "agent-table" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.agentePerformance, function (agente) {
                return _c("tr", { key: agente.nombre }, [
                  _c("td", [
                    _c("div", { staticClass: "agent-info" }, [
                      _c(
                        "div",
                        {
                          staticClass: "agent-avatar",
                          style: {
                            background: _vm.avatarColor(agente.nombre),
                          },
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.initialsOf(agente.nombre)) +
                              "\n                                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "agent-name" }, [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(agente.nombre) +
                            "\n                                "
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-center" }, [
                    _c("span", { staticClass: "cell-bubble bubble-progress" }, [
                      _vm._v(_vm._s(agente.en_proceso || 0)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-center" }, [
                    _c("span", { staticClass: "cell-bubble bubble-done" }, [
                      _vm._v(_vm._s(agente.resueltas || 0)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-center" }, [
                    _c("span", { staticClass: "cell-bubble bubble-total" }, [
                      _vm._v(_vm._s(agente.total || 0)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-center" }, [
                    _c("span", { staticClass: "cell-bubble bubble-overdue" }, [
                      _vm._v(_vm._s(agente.vencidas || 0)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-center" }, [
                    _c("span", { staticClass: "cell-bubble bubble-warning" }, [
                      _vm._v(_vm._s(agente.por_vencer || 0)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-center" }, [
                    _c("span", { staticClass: "cell-bubble bubble-time" }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(agente.tiempo_promedio || 0) +
                          "h\n                            "
                      ),
                    ]),
                  ]),
                ])
              }),
              _vm._v(" "),
              !_vm.agentePerformance || _vm.agentePerformance.length === 0
                ? _c("tr", [
                    _c(
                      "td",
                      { staticClass: "empty-row", attrs: { colspan: "7" } },
                      [
                        _vm._v(
                          "\n                            Sin agentes con solicitudes en el período\n                        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.showConnections
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("agent-connections", {
                attrs: { period: _vm.period, from: _vm.from, to: _vm.to },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chart-header" }, [
      _c("h5", [
        _c("i", { staticClass: "fal fa-users text-primary" }),
        _vm._v(" Rendimiento de\n                Agentes\n            "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("AGENTE")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("EN PROCESO")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("RESUELTAS")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("TOTAL")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("VENCIDAS")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("POR VENCER")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("T. PROMEDIO")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }